var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Test Dialog")]),_c('v-btn',{on:{"click":function($event){return _vm.MIX_puDialog(false, '')}}},[_vm._v("Close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }